import { DefaultTheme } from 'styled-components'
import { colors } from 'utils/colors'
import { font } from 'utils/fonts'
import { breakpoints, size } from 'utils/responsive'

const theme: DefaultTheme = {
  breakpoints,
  colors,
  font,
  size,
}

export default theme
